export const SOURCE_NAME = 'customiseSidebar';
export const CONTAINER_TYPE = 'sidebar-nav4';
export const CONTAINER_ID = 'sidebar-content';
